import axios, { AxiosResponse } from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';
import type { Action } from 'element-plus'
import router from '@/router';
const env = process.env as any;
const server = env.VUE_APP_DB_URL + "/api";
const host = env.VUE_APP_DB_URL;

class Query {

  sort?: string[];
  size?: number = 30;
  page?: number = 1;
  entity?: string | undefined = undefined;
  interface?: string | undefined = undefined;
}
class PostQuery {
    jsonText?: {}
    user_id?: string | undefined = undefined;
    token?: string | undefined = undefined
}


class JavaAPI {

  findId(doc: any) {
    if (!doc) {
      return undefined;
    }
    let valueId: string | undefined = undefined;

    if (doc["id"]) {
      valueId = doc["id"] + "";
    } else if (typeof doc == 'string' || typeof doc == 'number') {
      valueId = doc + "";
    }

    return valueId;
  }
  async delete(entity: string, doc: any) {
    const url = server + "/" + entity
    console.debug("url:", url)

    const id = this.findId(doc);
    const results = await axios.delete(url + "/" + id)
    if (results.data) {
      return results.data;
    }
    return results;
  }

  async getById(doc: any, entity: string) {
    const valueId = this.findId(doc);
    const url = server + "/" + entity
    console.debug("url:", url)

    const id = this.findId(doc);
    const results = await axios.get(url + "/" + id)
    if (results.data) {
      return results.data;
    }
    return results;
  }

  async getEntity(query: Query, doc: any) {
    const url = server + "/" + query.entity + "/search/" + query.interface
    const results = await axios.get(url, { params: doc })
    if (results.data) {
      return results.data;
    }
    if (results.data == 0) { 
      return 0;
    }
    return results;
  }

  async list(query: Query, doc: any) {
    const url = server + "/" + query.entity + "/search/" + query.interface
    const results = await axios.get(url, { params: doc })
    if (results.data) {
      return results.data._embedded;
    }
    return results;
  }


  // post接口的函数
  async postQuery(query,url1:String){
    const url = host + url1
    let config = {
      headers:{
          "Content-Type":"application/form-data"
      }
  }
  var formdata = new FormData();
  formdata.append("jsonText",JSON.stringify(query.jsonText));
  if(query.user_id){
    formdata.append("user_id",query.user_id);
  }
  if(query.token){
    formdata.append("token",query.token);
  }
  //console.log("formdata",formdata)
    const result = await axios.post(url,formdata,config).then(res=>{
      return res;
    },err=>{
      if(err.response.data.code == 10008){
        //登录超时
        ElMessageBox.alert(err.response.data.msg, '登录超时', {
          confirmButtonText: '确定',
          callback: (action: Action) => {
              this.removeLoginInfo()
              router.push({
                 name: 'login',
              })
              //console.log(err.response);
              return err.response;
          },
        })
      }else{
        if(err.response.data.msg)
        ElMessage.error(err.response.data.msg)
        
        //console.log(err.response);
        return err.response;
      }
    })
    return result.data;
  }

  // 移除登录信息
   removeLoginInfo = () => {
    localStorage.removeItem("token")
    localStorage.removeItem("user_id")
    localStorage.removeItem("organization_id")
    localStorage.removeItem("organization_name")
  }

  



}

const javaapi = new JavaAPI();

export default javaapi;
export { Query,PostQuery };
